import { fetchExportChild } from "@/api/profile";

export default {
  namespaced: true,
  state: {
    child: [],
    hasError: {},
  },

  mutations: {
    SET_EXPORT_CHILD(state, payload) {
      state.child = payload;
    },
    SET_ERROR(state, status) {
      state.hasError = status;
    },
  },

  actions: {
    async loadExportChild({ commit }) {
      try {
        const response = await fetchExportChild();
        commit("SET_EXPORT_CHILD", response.data);
        return response.data;
      } catch (error) {
        commit("SET_ERROR", error);
        throw error;
      }
    },
  },

  getters: {
    childrenList: (state) => state.child,
  },
};
